// /home/labdoo/zitech-nexus/frontend/src/pages/admin/SubscribersManagement.tsx
import React, { useState, useEffect } from 'react';
import { newsletterAPI } from '../../services/api';
import './SubscribersManagement.css';

// SVG Icons
const Icons = {
  Export: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  ),
  Search: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  Refresh: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10" />
      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
    </svg>
  ),
  Check: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  X: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Warning: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="sm-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  Users: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Active: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 8v4l3 3" />
    </svg>
  ),
  Inactive: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  ),
  Bounced: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Spam: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2.5" strokeLinecap="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Calendar: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  Envelope: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  Open: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Click: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12L8 7L13 12L8 17L3 12Z" />
      <path d="M8 17L13 12L18 17L13 22L8 17Z" />
    </svg>
  ),
};

interface Subscriber {
  id: string;
  email: string;
  name: string;
  status: 'active' | 'unsubscribed' | 'bounced' | 'spam';
  subscribed_at: string;
  confirmed_at: string | null;
  confirmation_sent_at: string | null;
  total_emails_sent: number;
  total_opens: number;
  total_clicks: number;
}

const SubscribersManagement: React.FC = () => {
  const [subscribers, setSubscribers] = useState<Subscriber[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [selectedSubscribers, setSelectedSubscribers] = useState<string[]>([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState<string | null>(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState<{
    show: boolean;
    email: string;
    action: 'unsubscribe' | 'resend' | 'delete' | 'bulk';
    count?: number;
  }>({
    show: false,
    email: '',
    action: 'unsubscribe'
  });

  useEffect(() => {
    fetchSubscribers();
  }, [statusFilter, searchTerm]);

  const fetchSubscribers = async () => {
    try {
      setLoading(true);
      const params: any = {};
      if (statusFilter !== 'all') params.status = statusFilter;
      if (searchTerm) params.search = searchTerm;
      
      const response = await newsletterAPI.getSubscribers(params);
      setSubscribers(response.data);
    } catch (err: any) {
      console.error('Error fetching subscribers:', err);
      setError('Failed to load subscribers');
    } finally {
      setLoading(false);
    }
  };

  const handleUnsubscribe = async (email: string) => {
    setShowConfirmDialog({
      show: true,
      email,
      action: 'unsubscribe'
    });
  };

  const confirmUnsubscribe = async () => {
    const { email } = showConfirmDialog;
    try {
      setActionLoading(email);
      await newsletterAPI.unsubscribe({ 
        email, 
        reason: 'Admin action - Unsubscribed by administrator' 
      });
      await fetchSubscribers();
      setShowConfirmDialog({ show: false, email: '', action: 'unsubscribe' });
    } catch (err) {
      console.error('Error unsubscribing:', err);
      alert('Failed to unsubscribe user');
    } finally {
      setActionLoading(null);
    }
  };

  const handleResendConfirmation = async (email: string) => {
    setShowConfirmDialog({
      show: true,
      email,
      action: 'resend'
    });
  };

  const confirmResend = async () => {
    const { email } = showConfirmDialog;
    try {
      setActionLoading(email);
      await newsletterAPI.resendConfirmation({ email });
      alert(`Confirmation email resent to ${email}`);
      await fetchSubscribers();
      setShowConfirmDialog({ show: false, email: '', action: 'resend' });
    } catch (err) {
      console.error('Error resending confirmation:', err);
      alert('Failed to resend confirmation email');
    } finally {
      setActionLoading(null);
    }
  };

  const handleDelete = async (email: string) => {
    setShowConfirmDialog({
      show: true,
      email,
      action: 'delete'
    });
  };

  const confirmDelete = async () => {
    const { email } = showConfirmDialog;
    try {
      setActionLoading(email);
      await newsletterAPI.deleteSubscriber({ email });
      await fetchSubscribers();
      setShowConfirmDialog({ show: false, email: '', action: 'delete' });
    } catch (err) {
      console.error('Error deleting subscriber:', err);
      alert('Failed to delete subscriber');
    } finally {
      setActionLoading(null);
    }
  };

  const handleBulkAction = async (action: 'unsubscribe' | 'delete' | 'resend') => {
    if (!selectedSubscribers.length) return;
    
    setShowConfirmDialog({
      show: true,
      email: '',
      action: 'bulk',
      count: selectedSubscribers.length
    });
  };

  const confirmBulkAction = async () => {
    const { action } = showConfirmDialog;
    try {
      setActionLoading('bulk');
      
      for (const email of selectedSubscribers) {
        if (action === 'unsubscribe') {
          await newsletterAPI.unsubscribe({ 
            email, 
            reason: 'Bulk admin action' 
          });
        } else if (action === 'delete') {
          await newsletterAPI.deleteSubscriber({ email });
        } else if (action === 'resend') {
          await newsletterAPI.resendConfirmation({ email });
        }
      }
      
      setSelectedSubscribers([]);
      await fetchSubscribers();
      setShowConfirmDialog({ show: false, email: '', action: 'bulk' });
      
      alert(`✅ ${selectedSubscribers.length} subscribers ${action === 'unsubscribe' ? 'unsubscribed' : action === 'delete' ? 'deleted' : 'received confirmation emails'}`);
    } catch (err) {
      console.error('Error in bulk action:', err);
      alert('Failed to process bulk action');
    } finally {
      setActionLoading(null);
    }
  };

  const handleExportCSV = async () => {
    try {
      setExportLoading(true);
      const response = await newsletterAPI.exportSubscribers();
      
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `subscribers_${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error exporting:', err);
      alert('Failed to export subscribers');
    } finally {
      setExportLoading(false);
    }
  };

  const toggleSelectAll = () => {
    if (selectedSubscribers.length === subscribers.length) {
      setSelectedSubscribers([]);
    } else {
      setSelectedSubscribers(subscribers.map(s => s.email));
    }
  };

  const toggleSelect = (email: string) => {
    if (selectedSubscribers.includes(email)) {
      setSelectedSubscribers(selectedSubscribers.filter(e => e !== email));
    } else {
      setSelectedSubscribers([...selectedSubscribers, email]);
    }
  };

  const getStatusColor = (status: string) => {
    switch(status) {
      case 'active': return '#10b981';
      case 'unsubscribed': return '#ef4444';
      case 'bounced': return '#f59e0b';
      case 'spam': return '#6b7280';
      default: return '#6b7280';
    }
  };

  const getStatusBackground = (status: string) => {
    switch(status) {
      case 'active': return '#d1fae5';
      case 'unsubscribed': return '#fee2e2';
      case 'bounced': return '#fef3c7';
      case 'spam': return '#f3f4f6';
      default: return '#f3f4f6';
    }
  };

  const getStatusIcon = (status: string) => {
    switch(status) {
      case 'active': return <Icons.Active />;
      case 'unsubscribed': return <Icons.Inactive />;
      case 'bounced': return <Icons.Bounced />;
      case 'spam': return <Icons.Spam />;
      default: return null;
    }
  };

  const getStats = () => {
    const total = subscribers.length;
    const active = subscribers.filter(s => s.status === 'active').length;
    const unsubscribed = subscribers.filter(s => s.status === 'unsubscribed').length;
    const bounced = subscribers.filter(s => s.status === 'bounced').length;
    const spam = subscribers.filter(s => s.status === 'spam').length;
    const confirmed = subscribers.filter(s => s.confirmed_at).length;
    const unconfirmed = total - confirmed;
    
    return { total, active, unsubscribed, bounced, spam, confirmed, unconfirmed };
  };

  const stats = getStats();

  if (loading && subscribers.length === 0) {
    return (
      <div className="sm-loading-container">
        <div className="sm-spinner">
          <Icons.Spinner />
        </div>
        <p className="sm-loading-text">Loading subscribers...</p>
      </div>
    );
  }

  return (
    <div className="sm-container">
      {/* Stats Grid */}
      <div className="sm-stats-grid">
        <div className="sm-stat-card sm-stat-total">
          <div className="sm-stat-icon"><Icons.Users /></div>
          <div className="sm-stat-content">
            <span className="sm-stat-number">{stats.total}</span>
            <span className="sm-stat-label">Total</span>
          </div>
        </div>
        <div className="sm-stat-card sm-stat-active">
          <div className="sm-stat-icon"><Icons.Active /></div>
          <div className="sm-stat-content">
            <span className="sm-stat-number">{stats.active}</span>
            <span className="sm-stat-label">Active</span>
          </div>
        </div>
        <div className="sm-stat-card sm-stat-confirmed">
          <div className="sm-stat-icon"><Icons.Check /></div>
          <div className="sm-stat-content">
            <span className="sm-stat-number">{stats.confirmed}</span>
            <span className="sm-stat-label">Confirmed</span>
          </div>
        </div>
        <div className="sm-stat-card sm-stat-unconfirmed">
          <div className="sm-stat-icon"><Icons.X /></div>
          <div className="sm-stat-content">
            <span className="sm-stat-number">{stats.unconfirmed}</span>
            <span className="sm-stat-label">Unconfirmed</span>
          </div>
        </div>
        <div className="sm-stat-card sm-stat-unsubscribed">
          <div className="sm-stat-icon"><Icons.Inactive /></div>
          <div className="sm-stat-content">
            <span className="sm-stat-number">{stats.unsubscribed}</span>
            <span className="sm-stat-label">Unsubscribed</span>
          </div>
        </div>
        <div className="sm-stat-card sm-stat-bounced">
          <div className="sm-stat-icon"><Icons.Bounced /></div>
          <div className="sm-stat-content">
            <span className="sm-stat-number">{stats.bounced + stats.spam}</span>
            <span className="sm-stat-label">Bounced/Spam</span>
          </div>
        </div>
      </div>

      {/* Header */}
      <div className="sm-header">
        <div className="sm-header-left">
          <h1 className="sm-title">Subscribers Management</h1>
          <p className="sm-subtitle">Manage your newsletter subscribers and their status</p>
        </div>
        <div className="sm-header-actions">
          <button 
            className="sm-btn-export" 
            onClick={handleExportCSV}
            disabled={exportLoading}
          >
            {exportLoading ? (
              <span className="sm-spinner-small"></span>
            ) : (
              <>
                <Icons.Export />
                Export CSV
              </>
            )}
          </button>
          
          {selectedSubscribers.length > 0 && (
            <div className="sm-bulk-actions">
              <button 
                className="sm-btn-bulk sm-btn-bulk-unsubscribe"
                onClick={() => handleBulkAction('unsubscribe')}
                disabled={actionLoading === 'bulk'}
              >
                Unsubscribe ({selectedSubscribers.length})
              </button>
              <button 
                className="sm-btn-bulk sm-btn-bulk-resend"
                onClick={() => handleBulkAction('resend')}
                disabled={actionLoading === 'bulk'}
              >
                Resend ({selectedSubscribers.length})
              </button>
              <button 
                className="sm-btn-bulk sm-btn-bulk-delete"
                onClick={() => handleBulkAction('delete')}
                disabled={actionLoading === 'bulk'}
              >
                Delete ({selectedSubscribers.length})
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Filters */}
      <div className="sm-filters">
        <div className="sm-search">
          <Icons.Search />
          <input
            type="text"
            placeholder="Search by email or name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && fetchSubscribers()}
          />
          <button onClick={fetchSubscribers} className="sm-search-btn">
            <Icons.Search />
          </button>
        </div>
        <div className="sm-filter-group">
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="unsubscribed">Unsubscribed</option>
            <option value="bounced">Bounced</option>
            <option value="spam">Marked as Spam</option>
          </select>
          <button onClick={fetchSubscribers} className="sm-refresh-btn">
            <Icons.Refresh />
            Refresh
          </button>
        </div>
      </div>

      {error && (
        <div className="sm-error">
          <span className="sm-error-icon">⚠️</span>
          <span>{error}</span>
        </div>
      )}

      {/* Table */}
      <div className="sm-table-wrapper">
        <table className="sm-table">
          <thead>
            <tr>
              <th className="sm-col-checkbox">
                <input
                  type="checkbox"
                  checked={selectedSubscribers.length === subscribers.length && subscribers.length > 0}
                  onChange={toggleSelectAll}
                />
              </th>
              <th className="sm-col-email">Email</th>
              <th className="sm-col-name">Name</th>
              <th className="sm-col-status">Status</th>
              <th className="sm-col-subscribed">Subscribed</th>
              <th className="sm-col-confirmed">Confirmed</th>
              <th className="sm-col-sent">Sent</th>
              <th className="sm-col-opens">Opens</th>
              <th className="sm-col-clicks">Clicks</th>
              <th className="sm-col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {subscribers.length === 0 ? (
              <tr>
                <td colSpan={10} className="sm-empty-state">
                  <Icons.Users />
                  <p className="sm-empty-text">No subscribers found</p>
                  <p className="sm-empty-subtext">Try adjusting your search or filters</p>
                </td>
              </tr>
            ) : (
              subscribers.map((subscriber) => (
                <tr key={subscriber.id} className="sm-table-row">
                  <td className="sm-col-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedSubscribers.includes(subscriber.email)}
                      onChange={() => toggleSelect(subscriber.email)}
                    />
                  </td>
                  <td className="sm-col-email">
                    <span className="sm-email">{subscriber.email}</span>
                  </td>
                  <td className="sm-col-name">
                    <span className="sm-name">{subscriber.name || '-'}</span>
                  </td>
                  <td className="sm-col-status">
                    <span 
                      className="sm-status-badge"
                      style={{
                        background: getStatusBackground(subscriber.status),
                        color: getStatusColor(subscriber.status)
                      }}
                    >
                      {getStatusIcon(subscriber.status)}
                      {subscriber.status}
                    </span>
                  </td>
                  <td className="sm-col-subscribed">
                    <span className="sm-date">
                      <Icons.Calendar />
                      {new Date(subscriber.subscribed_at).toLocaleDateString()}
                    </span>
                  </td>
                  <td className="sm-col-confirmed">
                    {subscriber.confirmed_at ? (
                      <span className="sm-confirmed-yes">
                        <Icons.Check />
                        {new Date(subscriber.confirmed_at).toLocaleDateString()}
                      </span>
                    ) : (
                      <span className="sm-confirmed-no">
                        <Icons.X />
                        Unconfirmed
                      </span>
                    )}
                  </td>
                  <td className="sm-col-sent">
                    <span className="sm-sent">
                      <Icons.Envelope />
                      {subscriber.total_emails_sent}
                    </span>
                  </td>
                  <td className="sm-col-opens">
                    <span className="sm-opens">
                      <Icons.Open />
                      {subscriber.total_opens}
                    </span>
                  </td>
                  <td className="sm-col-clicks">
                    <span className="sm-clicks">
                      <Icons.Click />
                      {subscriber.total_clicks || 0}
                    </span>
                  </td>
                  <td className="sm-col-actions">
                    <div className="sm-actions">
                      {subscriber.status === 'active' && !subscriber.confirmed_at && (
                        <button 
                          className="sm-action-btn sm-action-resend"
                          onClick={() => handleResendConfirmation(subscriber.email)}
                          disabled={actionLoading === subscriber.email}
                          title="Resend Confirmation"
                        >
                          {actionLoading === subscriber.email ? (
                            <span className="sm-spinner-small"></span>
                          ) : (
                            'Resend'
                          )}
                        </button>
                      )}
                      {subscriber.status === 'active' && (
                        <button 
                          className="sm-action-btn sm-action-unsubscribe"
                          onClick={() => handleUnsubscribe(subscriber.email)}
                          disabled={actionLoading === subscriber.email}
                          title="Unsubscribe"
                        >
                          Unsubscribe
                        </button>
                      )}
                      <button 
                        className="sm-action-btn sm-action-delete"
                        onClick={() => handleDelete(subscriber.email)}
                        disabled={actionLoading === subscriber.email}
                        title="Delete permanently"
                      >
                        <Icons.X />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Confirmation Dialog */}
      {showConfirmDialog.show && (
        <div className="sm-dialog-overlay" onClick={() => setShowConfirmDialog({ show: false, email: '', action: 'unsubscribe' })}>
          <div className="sm-dialog" onClick={(e) => e.stopPropagation()}>
            <h3 className="sm-dialog-title">Confirm Action</h3>
            <div className="sm-dialog-content">
              {showConfirmDialog.action === 'unsubscribe' && (
                <p>Are you sure you want to unsubscribe <strong>{showConfirmDialog.email}</strong>?</p>
              )}
              {showConfirmDialog.action === 'resend' && (
                <p>Resend confirmation email to <strong>{showConfirmDialog.email}</strong>?</p>
              )}
              {showConfirmDialog.action === 'delete' && (
                <p>
                  <Icons.Warning />
                  Permanently delete <strong>{showConfirmDialog.email}</strong>? This action cannot be undone.
                </p>
              )}
              {showConfirmDialog.action === 'bulk' && (
                <p>
                  <Icons.Warning />
                  Apply action to <strong>{showConfirmDialog.count}</strong> selected subscribers?
                </p>
              )}
            </div>
            <div className="sm-dialog-actions">
              <button 
                className="sm-dialog-cancel"
                onClick={() => setShowConfirmDialog({ show: false, email: '', action: 'unsubscribe' })}
              >
                Cancel
              </button>
              <button 
                className="sm-dialog-confirm"
                onClick={() => {
                  if (showConfirmDialog.action === 'unsubscribe') confirmUnsubscribe();
                  else if (showConfirmDialog.action === 'resend') confirmResend();
                  else if (showConfirmDialog.action === 'delete') confirmDelete();
                  else if (showConfirmDialog.action === 'bulk') confirmBulkAction();
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscribersManagement;